import React from 'react';
import { Link } from 'react-router-dom';
import Dropdowns from '../Filters/Dropdowns/Dropdowns';
import CheckboxAndInput from '../CheckboxAndInput/CheckboxAndInput';
import BuildingFloorRoomDropdown from '../BuildingFloorRoomDropdown';
export default (props) => (
	<div>
		<form onSubmit={props.handleSubmit}>
			<div className="nameDesc">
				<div className="inputGroup">
					<p>Name: </p>
					<input
						placeholder={props.assets ? props.assets.name : ""}
						type="text"
						name="name"
						defaultValue={props.state.name}
						value={props.state.name}
						onChange={props.handleInputChange} />
				</div>
				<div className="inputGroup">
					<p>Description: </p>
					<input
						placeholder={props.assets ? props.assets.description : ""}
						type="text"
						name="description"
						defaultValue={props.state.description}
						value={props.state.description || ""}
						onChange={props.handleInputChange} />
				</div>
			</div>
			<div className="reservable">
				{/* <p>Schedulable: </p>
							<div className="inputGroup">
								<input
									type="checkbox"
									name="isReservable"
									value={props.state.isReservable}
									onChange={props.handleInputChange} />
							</div>
							<br/> */}
				<p>Fixed Resource: </p>
				<div className="inputGroup">
					<input
						type="checkbox"
						name="isFixed"
						value={props.state.isFixed || false}
						checked={props.state.isFixed}
						onChange={props.handleInputChange} />
				</div>
			</div>

			{
				props.state.isFixed ?
					<BuildingFloorRoomDropdown {...props} />
					:
					''
			}

			<hr />

			<div className="detailGroup">
				<div className="bottomAddHolder">
					<p>Resource Type:</p>
					<div className="dnvHolder">
						<Dropdowns
							placeholderName="Resource Type"
							name="assetTypeId"
							form={true}
							type="select"
							filterClassName="{item.filterClass}"
							defaultValue={props.state.assetTypeId}
							items={props.assetTypes}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>

				<div className="bottomAddHolder right">
					<p>Resource Details:</p>
					<div className="rdMultiSelect">
						<div className="headers">
							<p className="detail">Detail</p>
						</div>
						<div className="dnvHolder">
							<CheckboxAndInput
								keyName="assetDetailTypeId"
								items={props.assetDetailTypes}
								isEdit={props.isEdit}
								state={props.state.assetDetails}
								name="assetDetails"
								onChange={props.handleCheckboxAndInputChange}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="formControls">
				<Link className="addCancel" to="/resources">Cancel</Link>
				<input className="addSubmit" type="submit" value={props.editValue ? "Edit Resource" : "Add Resource"} />
			</div>
		</form>
	</div>
);



// WEBPACK FOOTER //
// ./src/Components/Pages/ResourcesEditAddComponent.js